import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addDays, todayISO } from "@/lib/format";

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-1.5 min-w-0">
    <span className="eyebrow text-[#6b6b6b] !text-[10px]">{label}</span>
    {children}
  </label>
);

export default function SearchBar({ properties = [], defaultSlug = "udaipur" }) {
  const nav = useNavigate();
  const today = todayISO();
  const [f, setF] = useState({ property: defaultSlug, check_in: addDays(today, 1), check_out: addDays(today, 2), adults: 2, children: 0, rooms: 1 });
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const bookable = properties.filter((p) => !p.coming_soon);

  const submit = (e) => {
    e.preventDefault();
    const co = f.check_out <= f.check_in ? addDays(f.check_in, 1) : f.check_out;
    nav(`/book?${new URLSearchParams({ ...f, check_out: co }).toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="search-bar" className="bg-[#FDFBF7]/95 backdrop-blur-xl border border-white/30 shadow-2xl p-5 sm:p-6 grid gap-4 grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_.6fr_.6fr_.6fr_auto] items-end">
      <div className="col-span-2 lg:col-span-1">
        <Field label="Hotel">
          <select className="field" value={f.property} onChange={set("property")} data-testid="search-property-select">
            {(bookable.length ? bookable : [{ slug: "udaipur", name: "The Ananta Udaipur" }]).map((p) => <option key={p.slug} value={p.slug}>{p.name}</option>)}
          </select>
        </Field>
      </div>
      <Field label="Check-in"><input type="date" className="field" min={today} value={f.check_in} onChange={set("check_in")} required data-testid="search-checkin-input" /></Field>
      <Field label="Check-out"><input type="date" className="field" min={addDays(f.check_in, 1)} value={f.check_out} onChange={set("check_out")} required data-testid="search-checkout-input" /></Field>
      <Field label="Adults"><input type="number" min={1} max={40} className="field" value={f.adults} onChange={set("adults")} data-testid="search-adults-input" /></Field>
      <Field label="Children"><input type="number" min={0} max={20} className="field" value={f.children} onChange={set("children")} data-testid="search-children-input" /></Field>
      <Field label="Rooms"><input type="number" min={1} max={20} className="field" value={f.rooms} onChange={set("rooms")} data-testid="search-rooms-input" /></Field>
      <button type="submit" className="btn-primary col-span-2 lg:col-span-1 w-full" data-testid="search-check-availability-btn">Check Availability</button>
    </form>
  );
}
